import { Component, Input, OnInit } from '@angular/core';
import { GoogleTagManagerService } from '../core/analytics/google-tag-manager.service';
import { EnvironmentService } from '../core/enviroment/environment.service';
import {  Navigation, NavigationService } from 'lps-navigation';
import { GeolocationService } from '../core/services/geolocation/geolocation.service';
import { take } from 'rxjs/internal/operators/take';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cta-banner',
  templateUrl: './cta-banner.component.html',
  styleUrls: ['./cta-banner.component.scss']
})
export class CtaBannerComponent implements OnInit {

  constructor(
    private googleTagService: GoogleTagManagerService,
    private environmentService: EnvironmentService,
    private navigationService: NavigationService,
    private geolocationService: GeolocationService
  ) { }

  private baseUrl = this.environmentService.getBaseCrmUrl();
  private portalUrl = this.environmentService.getEnvVar('portal_url');
  private navigation: Navigation;

  ngOnInit(): void { }

  clickRedirectAgentPage(): void {

    this.findNavigation();

    this.publishTagEvent();

    const userNickname = this.navigation?.userProfile?.nickname;

    if (!!userNickname) {
      window.location.href = `${this.portalUrl}/associado/${userNickname}`;
    } else {
      throw new Error('Não foi possível redirecionar para a página do corretor');
    }
  }

  private publishTagEvent(): void {
    this.googleTagService.pushTag({
      event: 'event',
      eventCategory: 'crm:home',
      eventAction: 'clique:banner',
      eventLabel: '-',
    });
  }

  private findNavigation(): void  {
    this.geolocationService.getLocation().subscribe((value: any) => {
      this.navigationService.getNavigation('br', value)
      .pipe(take(1))
      .subscribe((navigationResponse) => {
        this.navigation = navigationResponse;
      })
    });
  }

}
